import React, { memo, useEffect, useState } from 'react'
import { Form, Input, InputNumber, Menu } from 'antd'
import { cloneDeep } from 'lodash-es'
import { ModalForm } from '@ant-design/pro-form'

export interface ComponentModalProps {
  trigger: JSX.Element
  component?: any
  onSuccess?: Function
  request: Function
}

const sections = [
  {
    key: 'admin',
    label: 'Admin',
  },
  {
    key: 'general',
    label: 'General',
  },
  {
    key: 'heat_capacity',
    label: 'Heat Capacity',
  },
  {
    key: 'antoine',
    label: 'Antoine',
  },
  {
    key: 'antoine',
    label: 'Peng-Robinson TWU',
  },
]

const ChemicalComponentModal = memo((props: ComponentModalProps) => {
  const { trigger, component, onSuccess, request } = props
  const [form] = Form.useForm<any>()
  const [activeKey, setActiveKey] = useState('admin')

  const initForm = () => {
    if (component && form) {
      form.setFieldsValue(cloneDeep(component))
    }
  }

  useEffect(() => {
    initForm()
  }, [component, form])

  return (
    <ModalForm
      layout='horizontal'
      labelCol={{ span: 6 }}
      form={form}
      title={component ? 'Edit Component' : 'New Component'}
      trigger={trigger}
      width={900}
      onVisibleChange={(visible) => {
        if (component && !visible) {
          initForm()
        }
        if (!component) {
          form.resetFields()
        }
      }}
      onFinish={async (values) => {
        try {
          await request(values, component)
          onSuccess?.()
          return true
        } catch {
          return false
        }
      }}
    >
      <Form.Item name='name' label='Name'>
        <Input />
      </Form.Item>
      <Form.Item name='formula' label='Formula'>
        <Input />
      </Form.Item>
      <Form.Item name='mw' label='Molecular Weight'>
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name='pc' label='Critical Pressure'>
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name='tc' label='Critical Temperature'>
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name='af' label='Acentric Factor'>
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name='cas' label='CAS No.'>
        <Input />
      </Form.Item>
      <Form.Item name='inchi' label='Inchi'>
        <Input />
      </Form.Item>
      <Form.Item name='inchiKey' label='Inchi Key'>
        <Input />
      </Form.Item>
    </ModalForm>
  )
})

export default ChemicalComponentModal
